
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Leagues from "../../modules/leagues/Leagues";
export default Leagues;
import { ModeIds } from "@chesshotel/constants";
export function getStaticPaths() {
    const modes = [
        ModeIds.BULLET,
        ModeIds.BLITZ,
        ModeIds.RAPID,
        ModeIds.CHESS960,
        ModeIds.DAILY,
    ];
    const paths = modes.map((mode) => ({
        params: {
            modeId: mode.toString(),
        },
    }));
    return {
        paths,
        fallback: true,
    };
}
const getStaticProps = async ({ params }) => {
    const { modeId } = params;
    return {
        props: { modeId },
    };
};

    async function __Next_Translate__getStaticProps__196976e9878__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/leagues/[modeId]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196976e9878__ as getStaticProps }
  